import React, { useEffect, useState } from "react"

import NotificationSnackbar from "@/components/ui/NotificationSnackbar"
import { useWeatherRun } from "./WeatherRunProvider"
import { newRunMessage } from "./weatherRunModel"

// Toast + bell entry once per newly activated run (never on first load or rollback).
export default function WeatherRunNotifier({ addNotification }) {
  const announcement = useWeatherRun()?.announcement ?? null
  const [toast, setToast] = useState(null)

  useEffect(() => {
    if (!announcement) return
    const message = newRunMessage(announcement.run)
    addNotification?.({ message, type: "info" })
    setToast(message)
  }, [announcement, addNotification])

  return (
    <NotificationSnackbar
      open={Boolean(toast)}
      message={toast}
      severity="info"
      title="Weather update"
      autoHideDuration={10000}
      onClose={() => setToast(null)}
    />
  )
}
